import QdtComponents from 'qdt-components'

export default ({ app }, inject) => {
  const host = app.$host

  const appId = '6c6a4d8a-129e-4681-bd39-7171deacebf1'

  const config = {
    host,
    prefix: '',
    port: 443, // window.location.port,
    secure: true,
    appId,
  }
  const connections = {
    vizApi: true,
    engineApi: true,
  }
  const qdtComponents = new QdtComponents(config, connections)

  inject('qdt', qdtComponents)
}